<template>
	<div :class="product && 'is-selected'">
		<div class="vx-row pt-1 pb-1" v-if="index > 0">
			<div class="vx-col w-full">
				<vs-divider />
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-1/12">
				<Quantity :quantity="this.product.quantity" />
			</div>
			<div class="vx-col w-1/12">
				<productcondition :order="order" :product="product" />
			</div>
			<div class="vx-col w-9/12">
				<div class="flex h-full items-center text-left">
					{{ this.product.title }}
				</div>
			</div>
			<div class="vx-col w-1/12 pr-5">
				<div class="flex h-full items-center float-right">
					<vx-tooltip text="Verkoopprijs">
						€{{ this.product.unit_price }}
					</vx-tooltip>
				</div>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-3/12">
				<div class="flex h-full items-center">
					<vx-tooltip text="Product ean">
						{{ this.product.ean }}
					</vx-tooltip>
					<vx-tooltip text="Kopieer product ean">
						<font-awesome-icon class="fa-icon cursor-pointer ml-2"
										   :icon="['far', 'copy']"
										   style="font-size: 1.0rem"
										   @click="copyEan" />
					</vx-tooltip>
					<vx-tooltip :text="printEanToolTipText()">
						<font-awesome-icon @click="printEanLabel" class="fa-icon cursor-pointer ml-2"
										   :icon="['fas', 'print']"
										   style="font-size: 1.0rem"
						/>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-col w-2/12">
				<productfullfilment :order="order" :product="product" />
			</div>
			<div class="vx-col w-5/12 items-center">
				<div class="vx-row">
					<div class="vx-col w-4/12">
						<vx-tooltip text="Interne referentie">
							<vs-chip class="float-none" v-if="this.product.reference">
								{{ this.product.reference }}
							</vs-chip>
							<vs-chip class="float-none text-sm" v-else>
								-
							</vs-chip>
						</vx-tooltip>
					</div>

					<div class="vx-col w-4/12">
						<vx-tooltip text="Opslaglocatie">
							<vs-chip class="float-none" v-if="this.product.location">
								{{ this.product.location }}
							</vs-chip>
							<vs-chip class="float-none text-sm" v-else>
								-
							</vs-chip>
						</vx-tooltip>
					</div>

					<div class="vx-col w-4/12">
						<vx-tooltip text="Verpakking">
							<!--									<vs-chip class="float-none" v-if="this.product.offer.package">-->
							<!--										{{ this.product.offer.package.name }}-->
							<!--									</vs-chip>-->
							<!--									<vs-chip class="float-none text-sm" v-else>-->
							<!--										- -->
							<!--									</vs-chip>-->
							<vs-chip class="float-none text-sm">
								-
							</vs-chip>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<div class="vx-col w-2/12 pr-5 h-full items-center text-right">
				<div class="flex h-full items-center float-right">
					<vx-tooltip text="Bemiddelingsbijdrage">
						-{{ this.product.unit_commission }}
					</vx-tooltip>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Productcondition from './productcondition';
import Quantity from './quantity';
import dymoPrinter from '../../../services/dymo/dymoPrinter';
import ean from '../../../services/dymo/labels/ean';
import Productfullfilment from '@/views/orders/product/productfullfilment';

export default {
	components: {
		Productfullfilment,
		Quantity,
		Productcondition
	},
	props: {
		order: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		},
		index: null
	},
	methods: {
		copyEan() {
			this.$copyText(this.product.ean).then(result => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Deze ean code is succesvol naar je klembord gekopieerd!',
					color: 'success',
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het kopiëren is mislukt!',
					color: 'danger',
				});
			});
		},
		printEanToolTipText() {
			if (!this.dymoPrinter.eanPrinterReady()) {
				return 'Er is geen verbinding met de ean label printer';
			}

			return 'Print ean label';
		},
		printEanLabel() {
			if (!this.dymoPrinter.eanPrinterReady()) {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er is geen verbinding met de ean label printer',
					color: 'danger'
				});
			}
			this.dymoPrinter.printEanLabel(this.product);
		},
	}
}
</script>

<style lang="scss">
.vx-card.is-selected {
	background-color: rgba(var(--vs-primary), 0.05);
	-webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
	box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.vs-tooltip {
	z-index: 99999 !important;
}
</style>
